export const BASE_IMAGE_ALT = 'Photo';
